import React, { Fragment } from "react";
import Icon, { IconName } from "./icon";
var SiteOverlay = function SiteOverlay(_ref) {
    var children = _ref.children, _ref$open = _ref.open, open = _ref$open === void 0 ? false : _ref$open, _ref$maxWidthContent = _ref.maxWidthContent, maxWidthContent = _ref$maxWidthContent === void 0 ? 600 : _ref$maxWidthContent, onClose = _ref.onClose;
    if (open) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "fixed inset-0 z-50",
            style: {
                backgroundColor: "rgba(0,0,0,0.6)"
            }
        }, /*#__PURE__*/ React.createElement("button", {
            className: "absolute top-0 right-0 p-4 focus:outline-none",
            onClick: onClose
        }, /*#__PURE__*/ React.createElement(Icon, {
            iconName: IconName.CLOSE,
            className: "w-12"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "w-full h-full flex flex-col justify-center mx-auto",
            style: {
                maxWidth: maxWidthContent + "px"
            }
        }, /*#__PURE__*/ React.createElement("div", null, children)));
    }
    return /*#__PURE__*/ React.createElement(Fragment, null);
};
export default SiteOverlay;
